import { StopEntry } from "../../StopEntry";
import { Checkbox, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEmptyStop extends Layout {
	checkbox1: Panel;
	checkboxAfterDispatch: Checkbox;
	checkboxAfterPrev: Checkbox;
	labelCurrent: Label;
	labelNext: Label;
	labelPrevMovement: Label;
	labelTitle: Label;
	labelTrailerDropSwap: Label;
	layoutStopEntry: StopEntry;
	panelDropTrailer: Panel;
	panelDropTrailerFields: Panel;
	panelEmptyMoveNext: Panel;
	panelEmptyMovePrevious: Panel;
	panelEmptyMovements: Panel;
	panelEquipmentDetails: Panel;
	panelTrailerContainer: Panel;
	sourceEmptyStop: DataSource;
	sourceStop: DataSource;
	switchDropTrailer: Switch;
	textboxEmptyDriver: Textbox;
	textboxEmptyTractor: Textbox;
	textboxTrailerDrop: Textbox;
	textboxTrailerPickup: Textbox;
}
